import {Col, Row} from "react-bootstrap";
import {Card} from "antd";
import {Chip} from "@material-ui/core";
import {orderStates, statusColors} from "../constants";
import {DateTime} from "luxon";
import {useMemo} from "react";

export default function OrderCard({item, onClick}) {

    const {ItemIds, Purchaser: {Name}, Issuer, Order: {Deadline, State, Number}} = item;

    const numberOfZeros = useMemo(() => {

        const maxNumber = 8

        if (!Number) return maxNumber;

        const nb = maxNumber - String(Number).length;

        if (nb < 0)
            return maxNumber;
        else
            return nb

    }, [Number])

    const handleClick = () => {
        onClick && onClick()
    }


    return (
        <Row style={{cursor: 'pointer', marginBottom: 10}} onDoubleClick={handleClick}>
            <Col>
                <Card>
                    <Row>

                        <Col className='my-auto'>
                            <h5>
                                {`C ${"0".repeat(numberOfZeros)}${Number ?? 0}`}
                            </h5>
                        </Col>

                        <Col className='my-auto'>
                            <h5>{ItemIds.length} Produit(s)</h5>
                        </Col>

                        <Col className='my-auto'>
                            <p className='my-auto'>Affectée à "<b>{Name}</b>"</p>
                        </Col>
                        <Col className='my-auto'>
                            <p className='my-auto'>Creé par "<b>{Issuer.Name}</b>"</p>
                        </Col>
                        <Col className='my-auto'>
                            <p className='my-auto'>{`Deadline ${DateTime.fromJSDate(Deadline.toDate()).toFormat('dd-MM-yyyy')}`}</p>
                        </Col>
                        <Col className='my-auto'>
                            <Chip style={{backgroundColor: statusColors(State), color: "white"}}
                                  label={orderStates.find(one => one.value === State).label}
                            />
                        </Col>
                        
                    </Row>

                </Card>
            </Col>
        </Row>
    )
}